// src/services/routeService.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************

import {
  getParams,
  getQuery,
  getUrlEndpoint,
  mergeUrlParamsQuery,
  updateUrl,
} from 'utils/urlUtils';
import useZustand from 'hooks/useZustand';

// *******************************************************************************
// METHODS
// *******************************************************************************

const updateUrlToId = _id => {
  if (!_id) return;

  const storedCurrentPage = useZustand('module', 'currentPage', false);
  const storedModule = useZustand('module', 'config', false);

  const currentQuery = getQuery();
  const currentEndpoint = getUrlEndpoint();

  // Get paramKey from page config (e.g., 'subscriptionId', '_id')
  const pageParamKey = storedCurrentPage?.routing?.paramKey || '_id';

  // Build schema URL from module config to extract current params
  const moduleUrl = storedModule?.url || '';
  const pageEndpoint = storedCurrentPage?.routing?.endpoint || '';
  const schemaUrl = moduleUrl + pageEndpoint;

  // Extract current URL params (preserves userId, etc.)
  const currentParams = schemaUrl ? getParams(currentEndpoint, schemaUrl) : {};

  // Replace 'add' with the new document ID using the correct paramKey
  currentParams[pageParamKey] = _id;

  // Build the new URL with updated params
  const newUrl = mergeUrlParamsQuery({
    url: moduleUrl,
    endpoint: pageEndpoint,
    params: currentParams,
    query: currentQuery,
  });

  // Update URL without navigation/reload
  updateUrl(newUrl, true);
};

const updateUrlToAdd = () => {
  const storedCurrentPage = useZustand('module', 'currentPage', false);
  const storedModule = useZustand('module', 'config', false);

  const currentQuery = getQuery();
  const currentEndpoint = getUrlEndpoint();

  // Get paramKey from page config (e.g., 'subscriptionId', '_id')
  const pageParamKey = storedCurrentPage?.routing?.paramKey || '_id';

  // Build schema URL from module config to extract current params
  const moduleUrl = storedModule?.url || '';
  const pageEndpoint = storedCurrentPage?.routing?.endpoint || '';
  const schemaUrl = moduleUrl + pageEndpoint;

  // Extract current URL params (preserves userId, etc.)
  const currentParams = schemaUrl ? getParams(currentEndpoint, schemaUrl) : {};

  // Replace 'add' with the new document ID using the correct paramKey
  currentParams[pageParamKey] = 'add';

  // Build the new URL with updated params
  const newUrl = mergeUrlParamsQuery({
    url: moduleUrl,
    endpoint: pageEndpoint,
    params: currentParams,
    query: currentQuery,
  });

  // Update URL without navigation/reload
  updateUrl(newUrl, true);
};

// *******************************************************************************
// SERVICE
// *******************************************************************************
const routeService = {
  updateUrlToAdd,
  updateUrlToId,
};

// *******************************************************************************
// EXPORTS
// *******************************************************************************
export default routeService;

// *******************************************************************************
// HELPERS
// *******************************************************************************
